import EstoqueLote from "model/suprimentos/EstoqueLote";
import ItemEmprestimo from "./ItemEmprestimo";
import { BaseEditModel } from "model/BaseEditModel";

export default class LoteItemEmprestimo implements BaseEditModel {

    id: number;
    codigo: string | null = "";
    key: string | null;
    sequencial: number | null;
    estoqueLote: EstoqueLote | null;
    quantidadeEmprestada: number;
    quantidadeInutilizavel: number;
    itemEmprestimo: ItemEmprestimo | null;

    constructor(
        id: number = 0,
        key: string = "",
        sequencial: number = 0,
        estoqueLote = null,
        quantidadeEmprestada: number = 0,
        quantidadeInutilizada: number = 0,
        itemEmprestimo: any = null,
    ) {
        this.id = id;
        this.key = key;
        this.sequencial = sequencial;
        this.estoqueLote = estoqueLote;
        this.quantidadeEmprestada = quantidadeEmprestada;
        this.quantidadeInutilizavel = quantidadeInutilizada;
        this.itemEmprestimo = itemEmprestimo;
    }
}